import { FC } from 'react'
import { AccordionContent, AccordionHeading } from '@yuno/sdk-web-core/dist/ui'
import {
  Heading,
  Instructions,
  OrderAccordion,
  OrderContainer,
  OrderTotalPurchase,
  OrderTotalPurchaseContainer,
} from './order.styled'
import {
  OrderDetailContent,
  OrderDetailPurchase,
  OrderDetailTitle,
  OrderTotal,
} from './order-components'
import { useOrder } from './use-order'
import { ORDER_DETAILS_ID, ORDER_ID } from './order.constants'
import { useTranslation } from 'react-i18next'
import { useDescription } from '../../hooks'

export const Order: FC = () => {
  const {
    openAccordion,
    onChange,
    order,
    airline,
    totalDue,
    currency,
    hasProducts,
  } = useOrder()
  const { t } = useTranslation()
  const { description } = useDescription()

  return (
    <OrderContainer>
      <Heading>{t('Review your order')}</Heading>
      {description && <Instructions>{description}</Instructions>}
      {order?.items && (
        <>
          <OrderAccordion onChange={onChange}>
            <AccordionHeading
              id={ORDER_ID}
              ariaControls={ORDER_DETAILS_ID}
              open={true}
            >
              <OrderDetailTitle isOpen={openAccordion === ORDER_DETAILS_ID} />
            </AccordionHeading>
            <AccordionContent id={ORDER_DETAILS_ID} ariaLabelledBy={ORDER_ID}>
              {order.items.map((item, index) => (
                <OrderDetailContent key={index} {...item} />
              ))}
            </AccordionContent>
          </OrderAccordion>
        </>
      )}
      <OrderTotalPurchase hasProducts={hasProducts}>
        <OrderTotalPurchaseContainer hasProducts={hasProducts}>
          <OrderTotal
            totalDue={totalDue}
            currency={currency}
            hasProducts={hasProducts}
          />
          {airline?.legs && <OrderDetailPurchase items={airline.legs} />}
        </OrderTotalPurchaseContainer>
      </OrderTotalPurchase>
    </OrderContainer>
  )
}
